import Logo from "@/components/Logo";
import { WHATSAPP_URL, WhatsAppIcon } from "@/components/WhatsApp";
import { useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-[#212631] bg-[#040507] py-12 px-6 text-xs text-[#8c98a9]" data-testid="footer">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-3">
          <Logo size={30} className="rounded-lg" />
          <span className="font-geom text-sm font-bold text-white tracking-widest">PRESTIGE DRIVE</span>
          <span className="font-mono text-[10px] text-[#c9a24d]">Grande Remise France</span>
        </div>
        <div className="font-mono text-center md:text-right space-y-2">
          <div>{t("footer.line")}</div>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link"
            aria-label={t("wa.aria")}
            className="inline-flex items-center text-[#25D366] hover:brightness-110 hover:scale-110 transition-all">
            <WhatsAppIcon className="w-5 h-5" />
          </a>
        </div>
      </div>
    </footer>
  );
}
